import { Controller } from "@hotwired/stimulus"

// Simple notification controller for autosave status
export default class extends Controller {
  connect() {
    // Auto-dismiss notification after 3 seconds
    setTimeout(() => {
      this.element.classList.add('opacity-0')
      setTimeout(() => this.element.remove(), 300)
    }, 3000)
  }
}